import React, { Component } from 'react';
import { withRouter } from 'react-router-dom';
import { Jumbotron } from 'react-bootstrap';
import { connect } from 'react-redux';
import Notifications from 'react-notify-toast';
import Routes from 'app/Routes';
import { getSession } from 'libs/sessionStorage';
import MainNav from 'containers/MainNav';
import Footer from 'containers/Footer';
import Maintenance from 'containers/Maintenance';
import { Preloader } from 'ctia-ui';
import Notifier from 'components/Notifier';
import FccIdChecker from 'components/FccIdChecker';
import AppWindow from 'components/AppWindow';
import TermsOfUse from 'containers/TermsOfUse';
import { tokenTimeout } from 'dictionaries/Env';
import { refreshToken, getUserInfo } from 'actions/user';
import { getSystemInfo } from 'actions/system';

import 'styles/App.css';
import 'styles/Preloader.css';

class App extends Component {
  componentDidMount() {
    this.appLogin();
    this.props.getSystemInfo();
  }

  componentWillUnmount() {
    clearInterval(this.restore);
  }

  componentWillUpdate() {
    const user = getSession('user');
    if (!user) {
      clearInterval(this.restore);
    }
  }

  updateUser = () => {
    return this.props.refreshToken(this.props.getUserInfo);
  };

  appLogin() {
    const user = getSession('user');

    if (user) {
      const { history, location } = this.props;

      // to keep current opened page/view
      history.push(location.pathname);

      // need to refresh old stored token for the first time
      this.updateUser();

      // refresh token each 30 minutes
      this.restore = setInterval(() => this.updateUser, tokenTimeout);
    }
  }

  render() {
    const { user, history, preloader, system } = this.props;

    // show maintenance page if server is off
    if (system && system.serverIsDown) {
      return <Maintenance />;
    }

    // get user data from redux store
    const userData = {
      ...user,
      history
    };

    // add preloader class if preloader is active
    const articleWrapper = preloader ? 'curtain' : '';

    // show terms of use if new user is coming
    const sessionTerms = getSession('terms');
    const termsNotAccepted =
      user && (user.cbrsagreementflag === 0 || user.cbrsagreementflag === '');
    if (termsNotAccepted && !sessionTerms) {
      return <TermsOfUse history={history} />;
    }

    return (
      <div className="root-container">
        <Preloader show={preloader} />
        <AppWindow />
        <div className={`root-container ${articleWrapper}`}>
          <Notifications />
          <Notifier />
          <header id="header">
            <MainNav user={userData} />
          </header>
          <article id="contentWrapper">
            <div className="content">
              <FccIdChecker />
              <Jumbotron bsClass="Jumbo">
                <Routes childProps={{ user: userData }} />
              </Jumbotron>
            </div>
          </article>
          <footer id="footer">
            <Footer user={user} />
          </footer>
        </div>
      </div>
    );
  }
}

function mapStateToProps({ user, preloader, notifier, system }) {
  return { user, preloader, notifier, system };
}

export default withRouter(
  connect(
    mapStateToProps,
    { refreshToken, getSystemInfo, getUserInfo }
  )(App)
);



// WEBPACK FOOTER //
// ./src/app/Main.js